import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import PublicDocumentUploadButton from 'pages/common/document/public-document-upload-button';

import PublicEstateDocumentPaper from './public-estate-document-paper';

type Props = {
  estateDocumentField: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  uploadedFile: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setUploadedFile: React.Dispatch<any>;
};

const useStyles = makeStyles(() => ({
  documentAction: {
    textAlign: 'center',
  },
  documentDescription: {
    padding: '5px',
    paddingBottom: '15px',
    textAlign: 'center',
  },
  documentRow: {
    paddingTop: '15px',
    paddingBottom: '15px',
  },
  documentIcon: {
    textAlign: 'center',
    height: '108px',
  },
  warning: {
    display: 'block',
    color: 'red',
    fontSize: '.65rem',
    lineHeight: '1.3',
  },
}));

interface EstateDocumentDetail {
  [key: string]: {
    img: string;
    imgAlt: string;
    description: string;
    instruction?: string;
  };
}

const documentDetail: EstateDocumentDetail = {
  documentIdFrontOfPhotoId: {
    // truplanning and truproxy
    img: '/front-of-id.svg',
    imgAlt: 'front of photo id',
    description: 'Front of ID',
    instruction: '',
  },
  documentIdBackOfPhotoId: {
    // truplanning and truproxy
    img: '/back-of-id.svg',
    imgAlt: 'back of photo id',
    description: 'Back of ID',
    instruction: '',
  },
};

export default function PublicEstateDocumentUploadBox({
  estateDocumentField,
  uploadedFile,
  setUploadedFile,
}: Props) {
  const classes = useStyles();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const uploadCompleted = (file: any) => {
    setUploadedFile(file);
  };

  const deleteFile = () => {
    setUploadedFile(undefined);
  };

  return (
    <Grid key={estateDocumentField} className={classes.documentRow} item xs={6} sm={6}>
      <Grid className={classes.documentIcon} item xs={12} sm={12}>
        <img
          src={documentDetail[estateDocumentField].img}
          alt={documentDetail[estateDocumentField].imgAlt}
        />
      </Grid>
      <Grid className={classes.documentDescription} item xs={12} sm={12}>
        <Typography>{documentDetail[estateDocumentField].description}</Typography>
      </Grid>
      <Grid container justifyContent="center">
        <Grid className={classes.documentAction} item xs={10} sm={10}>
          {uploadedFile ? (
            <PublicEstateDocumentPaper file={uploadedFile} deleteFileFn={deleteFile} />
          ) : (
            <PublicDocumentUploadButton
              uploadCompletedFn={uploadCompleted}
              uploadType={estateDocumentField}
            />
          )}
        </Grid>
        <Grid className={classes.documentAction} item xs={12} sm={12}>
          <Typography variant="caption" className={classes.warning}>
            {documentDetail[estateDocumentField].instruction}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
